<template>
  <el-tooltip class="item" effect="dark" :content="engagerData.name || engagerData.identifier">
    <img
      class="img-circle"
      :src="showFallbackProfileImage ? identicon : engagerData.profileImg"
      @error="imageLoadError"
    >
  </el-tooltip>
</template>
<script>
import {
  getDataItem,
  getProfileIdenticon,
  getPrimaryIdentifier,
} from '@/components/profile/profileUtils';

export default {
  name: 'Engager',
  props: ['profile'],

  data: () => ({
    showFallbackProfileImage: false,
  }),

  computed: {
    engagerData() {
      return {
        name: this.getDataItem('personal', 'name'),
        identifier: getPrimaryIdentifier(this.profile),
        profileImg: this.getDataItem('personal', 'profile_image', this.identicon),
        count: this.profile.count,
      };
    },
    identicon() {
      return getProfileIdenticon(this.profile);
    },
  },

  methods: {
    getDataItem(profileSection, property, defaultValue) {
      return getDataItem(this.profile, profileSection, property, defaultValue);
    },

    imageLoadError() {
      this.showFallbackProfileImage = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// CampaignEngager.vue?28dfc2b5